import { render, staticRenderFns } from "./entity-card-user-management-profiles-detail-rights.vue?vue&type=template&id=6f90a4f6&"
import script from "./entity-card-user-management-profiles-detail-rights.vue?vue&type=script&lang=js&"
export * from "./entity-card-user-management-profiles-detail-rights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports